/**
 * Application version — single source of truth (consumed by every environment
 * as `appVersion`). See AGENTS.md §4.
 *
 * ACTUALIZAR EN CADA CAMBIO de código de la app.
 *
 * Formato: YYYY.MM.DD.NN
 *   YYYY.MM.DD — fecha de hoy (con cero a la izquierda)
 *   NN         — contador de veces que se actualizó HOY (2 o 3 dígitos: 01, 02 … 100)
 *
 * Reglas de cálculo:
 *   - Si la fecha ya es la de hoy  → incrementar NN (…05.01 → …05.02).
 *   - Si la fecha es anterior a hoy → fecha de hoy con NN = 01 (…05.07 → 2026.06.06.01).
 */
export const APP_VERSION = '2026.10.29.02';
